function insertTag(textarea, tag) {
	const start = textarea.selectionStart;
	const val = textarea.value;
	textarea.value = val.slice(0, start) + tag + val.slice(start);
	textarea.selectionStart = textarea.selectionEnd = start + tag.length;
	textarea.focus();
	textarea.dispatchEvent(new Event('input', { bubbles: true }));
}

export function initTagAutocomplete() {
	const container = document.getElementById('daily-messages');
	if (!container) return;

	// Track which textarea was last focused
	let activeTextarea = container.querySelector('textarea');
	container.addEventListener('focus', (e) => {
		if (e.target.matches('textarea')) activeTextarea = e.target;
	}, true);

	// Click tag button → insert into active textarea
	container.addEventListener('click', (e) => {
		const btn = e.target.closest('.msg-tag-btn');
		if (!btn || !activeTextarea) return;
		e.preventDefault();
		insertTag(activeTextarea, btn.dataset.tag);
	});
}
